import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class RentsProfitsError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('RentsProfitsError', ...args);
    }
}
export default RentsProfitsError;
